export const MerchantSelectionErrorViewMessages = {
  errorMessage: {
    id: 'Pages.MerchantSelection.Page.errorMessage',
    description: 'Error Message when failed to fetch Merchants',
  },
}
